"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortRoomsCount = sortRoomsCount;
var _constants = require("../../../constants");
function sortRoomsCount(rawValues) {
  return rawValues.sort((a, b) => _constants.sortRuleRoomsCount.indexOf(a.value) - _constants.sortRuleRoomsCount.indexOf(b.value));
}